/**
 * 根据权限配置菜单
 * 每一个menu项参数：label, path, number 显示提示数字, query 查询对象
 */
import Permit from '../utils/permit'
let menus = []
menus.push({ key: "dashboard", label: '主工作台', path: '/normal/dashboard', icon: 'dashboard' })
menus.push({ key: "perferenceUsers", label: '子账号', path: '/set/perference/users', icon: 'users' })
if (['charge'].includes(Permit.edition())) {
  menus.push({ key: "perferenceShops", label: '店铺', path: '/set/perference/shops', icon: 'shop' })
}

let pdm = { key: "pdm", label: '产品', icon: 'product', children: [] }
if (['charge', 'bf', 'af'].includes(Permit.edition())) {
  pdm.children.push({ key: "perferencePdmCategories", label: '分类', path: '/set/perference/pdm/categories' })
}
if (['charge', 'bf'].includes(Permit.edition())) {
  pdm.children.push({ key: "perferencePdmUnits", label: '单位', path: '/set/perference/pdm/units' })
  pdm.children.push({ key: "perferencePdmColors", label: '颜色', path: '/set/perference/pdm/colors' })
  pdm.children.push({ key: "perferencePdmSizes", label: '规格', path: '/set/perference/pdm/sizes' })
  pdm.children.push({ key: "perferencePdmAttributes", label: '自定义属性', path: '/set/perference/pdm/attributes' })
  pdm.children.push({ key: "perferencePdmBrands", label: '品牌', path: '/set/perference/pdm/brands' })
  pdm.children.push({ key: "perferencePdmLabels", label: '标签', path: '/set/perference/pdm/labels' })
  pdm.children.push({ key: "perferencePdmTagTemplates", label: '吊牌模板', path: '/set/perference/pdm/tag-templates' })
  pdm.children.push({ key: "perferencePdmCraftworkTemplates", label: '制作工艺模板', path: '/set/perference/pdm/craftwork-templates' })

}
if (pdm.children.length != 0) {
  menus.push(pdm)
}
if (['charge'].includes(Permit.edition())) {
  let oms = { key: "oms", label: '销售单', icon: 'oms', children: [] }
  menus.push(oms)
  oms.children.push({ key: "perferenceOmsCurrencies", label: '币种', path: '/set/perference/oms/currencies' })
  oms.children.push({ key: "perferenceOmsGroups", label: '订单分组', path: '/set/perference/oms/groups' })
  oms.children.push({ key: "perferenceOmsCustomerGroups", label: '客户分组', path: '/set/perference/oms/customer-groups' })
  oms.children.push({ key: "perferenceOmsBargainTemplates", label: '销售订单模板', path: '/set/perference/oms/bargain-templates' })
  oms.children.push({ key: "perferenceOmsRemarkTemplates", label: '订单备注模板', path: '/set/perference/oms/remark-templates' })

}
menus.push({ key: "perferencePayMethods", label: '收付款方式', path: '/set/perference/pay-methods', icon: 'payMethod' })

if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('mms')) {
  let mms = { key: "mms", label: '物料', icon: 'mms', children: [] }
  menus.push(mms)
  mms.children.push({ key: "perferenceMmsSubjects", label: '物料科目', path: '/set/perference/mms/subjects' })
  mms.children.push({ key: "perferenceMmsWarehouses", label: '物料仓', path: '/set/perference/mms/warehouses' })
}
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('mes')) {
  let mes = { key: "mes", label: '生产', icon: 'mes', children: [] }
  menus.push(mes)
  mes.children.push({ key: "perferenceMesPhaseGroups", label: '工序分组', path: '/set/perference/mes/phase-groups' })
  mes.children.push({ key: "perferenceMesPhases", label: '工序', path: '/set/perference/mes/phases' })
  // mes.children.push({ key: "perferenceMesWorkers", label: '工人', path: '/perference/mes/workers' })
  mes.children.push({ key: "perferenceMesFactories", label: '产线', path: '/set/perference/mes/factories' })
  mes.children.push({ key: "perferenceMesPhaseTemplates", label: '工序模板', path: '/set/perference/mes/phase-templates' })
  mes.children.push({ key: "perferenceMesWorkOrderTemplates", label: '生产单模板', path: '/set/perference/mes/work-order-templates' })
  mes.children.push({ key: "perferenceMesReworkTypes", label: '返工类型', path: '/set/perference/mes/rework-types' })

}
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('wms')) {
  let wms = { key: "wms", label: '库存', icon: 'wms', children: [] }
  menus.push(wms)
  wms.children.push({ key: "perferenceWmsWarehouses", label: '仓库', path: '/set/perference/wms/warehouses' })
  wms.children.push({ key: "perferenceWmsStockInTypes", label: '入库类型', path: '/set/perference/wms/stock-in-types' })
  wms.children.push({ key: "perferenceWmsStockOutTypes", label: '出库类型', path: '/set/perference/wms/stock-out-types' })
}
if (['charge', 'af'].includes(Permit.edition()) && (Permit.extendModels().includes('lmsE') || Permit.extendModels().includes('lmsC'))) {
  let lms = { key: "lms", label: '发货', icon: 'lms', children: [] }
  menus.push(lms)
  if (Permit.extendModels().includes('lmsE')) {
    lms.children.push({ key: "perferenceLmsExpresses", label: '国内快递', path: '/set/perference/lms/expresses' })
  }
  if (Permit.extendModels().includes('lmsC')) {
    lms.children.push({ key: "perferenceLmsCouriers", label: '国际快递', path: '/set/perference/lms/couriers' })
  }
}
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('rms')) {
  menus.push({ key: "perferenceRentTemplates", label: '租赁单模板', path: '/set/perference/rent-templates', icon: 'rent' })
}
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('schedule')) {
  menus.push({ key: "perferenceScheduleTypes", label: '日程类型', path: '/set/perference/schedule-types', icon: 'schedules' })
}
menus.push({ key: "perferenceSettings", label: '系统设置', path: '/set/perference/settings', icon: 'set' })

export default {
  items: menus
};